import { useEffect, useContext} from "react"
import {useEstadoApp} from "../context/EstadoAppContext";
//import { AuthContext } from '../context/authContext';
//usemos el componente InformesContainer
import InformesContainer from "../components/InformesContainer";

export const InformesPage = () => {

    const {estadoAppX, cambiarEstadoApp} = useEstadoApp();

    useEffect(() => {
        //console.log("estadoAppX", estadoAppX)
        cambiarEstadoApp("inicial")
    }, []) //cuando se monta el componente volver al estado inicial
    //const {isAuthenticated} = useContext(AuthContext)    

    // Mismo contenedor que ContactosONGPage.jsx:895. Antes esta página traía
    // `justify-center px-6 py-12 lg:px-8 dark:bg-black` y un wrapper `sm:max-w-sm`
    // copiado de un login: el centrado vertical, el `dark:bg-black` (que pisaba el
    // dark:bg-gray-900 del layout y dejaba el fondo negro) y el max-w-sm, que solo
    // envolvía al título y por lo tanto no hacía nada. El título que queda es el <h1>
    // de InformesContainer, que antes se veía sin estilo por no tener className.
    return (
        <div className="p-4">
            <InformesContainer />
        </div>
    )
}